(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-slide"] && !Shopify.designMode) return;
  try {
    

$(window).on('scroll', function() {
    // Get the number of pixels scrolled down from the top
    var scrollTop = $(this).scrollTop(); 

    if (scrollTop >= 50) {
        $('.toolbar_inner').addClass('fixed')
    } else {
        $('.toolbar_inner').removeClass('fixed')
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["detaillantsprods"] && !Shopify.designMode) return;
  try {
    
var a = new Array();

$('.grid-offline div.product-grid-item').each(function(index) {
  //text = $(this).html();
  text = $(this).attr('data-color');
    if($.inArray(text, a)!=-1){
        $(this).closest('div.product-grid-item').hide();
    }else{
        a.push(text);
    }
});

  var b = new Array();

$('.grid-online div.product-grid-item').each(function(index) {
    //text = $(this).html();
  text = $(this).attr('data-color');
    if($.inArray(text, b)!=-1){
        $(this).closest('div.product-grid-item').hide();
    }else{
        b.push(text);
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zone-tabs"] && !Shopify.designMode) return;
  try {
    

(function($) {
var alphabeticallyOrderedDivsAll = $('.media_section.all_collection .media_item').sort(function(a, b) {
  return String.prototype.localeCompare.call($(a).data('order'), $(b).data('order'));
});

var container = $(".grid-media");
container.detach().empty().append(alphabeticallyOrderedDivsAll);
$('.media_section.all_collection').append(container);

  $('div.media').addClass('visible');
   $('div.media_section.all_collection').addClass('visible');
  $('.accordion > .heading > a[data-name="Media"]').addClass('active');
    var $defaultitle = $('.inner_accordion .sub_title:first-child').html();
    console.log($defaultitle);

      $('.inner_accordion .sub_title:first-child').addClass('active');
 
    $('.media_item').each(function(){
       if($(this).attr('data-name') == $defaultitle){
         $(this).show();
       }else{
         $(this).hide();
       }
    });
$('.accordion__item__title').each(function(){
  $(this).click(function(){
    $(this).toggleClass('is-expanded');
    $(this).parent().find('.accordion__item__text-wrapper').toggleClass('is-expanded');
  })
});
 // var allPanels = $('.accordion > .inner_accordion').hide();
  var links = [];
  $('.accordion > .heading > a').click(function() {
    if($(this).attr('data-name') == 'Documents' || $(this).attr('data-name') == 'Documents'){
       $('.heading a').removeClass('active');
      $(this).addClass('active');
      $('div.documentation').addClass('visible');
      $('div.media').removeClass('visible');
      $('div.contact').removeClass('visible');
    }else if($(this).attr('data-name') == 'Media'){
      $('.heading a').removeClass('active');
      $(this).addClass('active');
      $('.sub_title').removeClass('active');
      $('.inner_accordion .sub_title:first-child').addClass('active');
      $('div.media').addClass('visible');
      // $('.media_section.all_collection').addClass('visible');
      // $('.media_item').each(function(){
      //   $(this).show();
      // });

      var $defaultitle = $('.inner_accordion .sub_title:first-child').html();
    console.log($defaultitle);
    $('.media_item').each(function(){
       if($(this).attr('data-name') == $defaultitle){
         $(this).show();
       }else{
         $(this).hide();
       }
    });
      $('div.documentation').removeClass('visible');
       $('div.contact').removeClass('visible');
    }else if($(this).attr('data-name') == 'Contact'){
      $('.heading a').removeClass('active');
      $(this).addClass('active');
      $('div.documentation').removeClass('visible');
      $('div.media').removeClass('visible');
       $('div.contact').addClass('visible');
    }else{
      $('.heading a').removeClass('active');
       $('div.documentation').removeClass('visible');
      $('div.media').removeClass('visible');
       $('div.contact').removeClass('visible');
    }
    $('.sub_title').each(function(){
      $(this).click(function(){
          var $name = $(this).attr('data-name');
         $('div.media').addClass('visible');
        $('div.contact').removeClass('visible');
         $('div.documentation').removeClass('visible');
         $('.media_item').each(function(){
           if($(this).attr('data-name') == $name){
             $(this).show();
           }else{
             $(this).hide();
           }
        });
      })
    })
   // allPanels.slideUp();
    $(this).parent().next().slideDown();
    return false;
    
  });

  $('.sub_title').each(function(){
    $(this).click(function(){
     // $('.media_section.all_collection').removeClass('visible');
      var $title = $(this).html();
      $('.sub_title').removeClass('active');
      $(this).addClass('active');
      $('.media_item').each(function(){
           if($(this).attr('data-name') == $title){
             $(this).show();
           }else{
             $(this).hide(); 
           }
        });
    });
  });

  $('input[name=media_input]').each(function(){
    $(this).click(function(){
      checked = $("input[type=checkbox]:checked").length;
        if(checked) {
          $('.downloadContainer').addClass('visible');
          links.push($(this).attr('value'));
          $('.count').html(checked);
         if($(this).prop("checked") == false){
              var valueInput = $(this).attr('value');
            links = jQuery.grep(links, function(value) {
              return value != valueInput;
            });
          }
        }else{
          $('.downloadContainer').removeClass('visible');
        }
       console.log(links);
      const promises = links.map(async (url) => {
        const res = await fetch(url);
        const blob = await res.blob();
        return blob;
      });
    })
  });    


$('#downloadAll').click(function(){

//Get image data
  const promises = links.map(async (url) => {
    const res = await fetch(url);
    const blob = await res.blob();
    //  var name = res.split('/').pop(); 
    console.log(name);
    return blob;
  //  return res; 
  });

 const startZip = async function(a, b) { 
    const res = await Promise.all(promises);
   // create zip
    var zip = new JSZip();
  // zip.file("README.txt", "Created with JSZip\n");
  // var img = zip.folder("images"); 
 
   $.each(res, function (index, blob) {
     
    //  var url = URL.createObjectURL(blob);
    //  var name = url.split('/').pop();
        zip.file("image"+ index +".jpg", blob);    //res.blob  //zip.file("image"+ index +".jpg", blob); 
    });
 
     const zipFile = await zip.generateAsync({type:"blob"});

  //Download results

    downloadZip(zipFile);
      }
   startZip();            
});

function downloadZip(file){
    const a = document.createElement('a');
    a.download = 'OlangMedia.zip';
    const url = URL.createObjectURL(file);
    a.href = url;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    a.remove();

    URL.revokeObjectURL(url);
  }

})(jQuery);

  } catch(e) { console.error(e); }
})();
})();
